import React, { useState, useEffect, useContext } from "react";
import { useNavigate } from "react-router";
import Button from "../material/button/Button";
import Input from "../material/input/Input";
import Select from "../material/select/Select";
import PageHeader from "../pageheader/PageHeader";
import * as publicApi from "../../service/publicApi";
import * as labPersonalApi from "../../service/labPersonalApi";

import ModaluploadResultsInput from "../material/modal/ModaluploadResultsInput";
import ManuOperation from "./navOperationRoom/ManuOperation";
import { v4 as uuidv4 } from "uuid";
import * as regex from "../../service/regex";

import styles from "./AddIndividualData.module.css";
import deleteIcon from "../../asset/image/delete.svg";
import { RedirectCode400 } from "../RedirectCode400";
import AutoComplete from "../material/autoComplete/AutoComplete";

import { CurrentUserContext } from "../../App";

import DataTable from "react-data-table-component";
import { colors } from "@mui/material";
const customStyles = {
  rows: {
    style: {
      // override the row height
      "&:nth-child(even)": {
        background: "#effff4",
      },
      "&:not(:last-of-type)": {
        borderBottomWidth: "none",
      },
    },
  },
  headCells: {
    style: {
      // override the cell padding for head cells
      display: "flex",
      justifyContent: "center",
      background: "#B8DFC7",
      fontSize: 18,
      "@media (max-width: 800px)": {
        fontSize: 14,
      },
    },
  },
  cells: {
    style: {
      // override the cell padding for data cells
      display: "flex",
      justifyContent: "center",
      borber: "1px solid #B8DFC7",
    },
  },
};

function AddIndividualData() {
  const { setIsMessage } = useContext(CurrentUserContext);

  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);

  const [testingNo, setTestingNo] = useState("");
  const [idCard, setIdCard] = useState("");
  const [hn, setHN] = useState("");
  const [prefix, setPrefix] = useState("");
  const [optionPrefix, setOptionPname] = useState([
    {
      key: "นาย",
      value: "นาย",
    },
    {
      key: "นาง",
      value: "นาง",
    },
    {
      key: "นางสาว",
      value: "นางสาว",
    },
    {
      key: "เด็กหญิง",
      value: "เด็กหญิง",
    },
    {
      key: "เด็กชาย",
      value: "เด็กชาย",
    },
  ]);
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");

  const [age, setAge] = useState("");
  const [gender, setGender] = useState("");
  const [optionGender, setOptionGender] = useState([
    {
      key: "male",
      value: "ชาย",
    },
    {
      key: "female",
      value: "หญิง",
    },
  ]);

  const [testingDate, setTestingDate] = useState("");
  const [receiveDate, setReceiveDate] = useState("");
  const [category, setCategory] = useState("");
  const [optionCategory, setOptionCategory] = useState([
    {
      key: "EDTA Blood",
      value: "EDTA Blood",
    },
    {
      key: "DNA",
      value: "DNA",
    },
    {
      key: "Buccal",
      value: "Buccal",
    },
  ]);
  const [sampleDescription, setSampleDescription] = useState("");
  const [submitDate, setSubmitDate] = useState("");
  const [collectDate, setCollectDate] = useState("");

  const [customerId, setCustomerId] = useState("");
  const [customerName, setCustomerName] = useState("");
  const [address, setAddress] = useState("");
  const [postCode, setPostCode] = useState("");

  const [testingGroup, setTestingGroup] = useState(""); //ประเภทการทดสอบ
  const [optionTestingGroup, setOptionTestingGroup] = useState([
    {
      key: "การตรวจวินิจฉัยทางเภสัชพันธุศาสตร์",
      value: "การตรวจวินิจฉัยทางเภสัชพันธุศาสตร์",
    },
  ]);

  const [testingGene, setTestingGene] = useState(""); //ชนิดการทดสอบยีน
  const [optionTestingGene, setOptionTestingGene] = useState([]);

  const [expr2, setExpr2] = useState(""); //ชื่อการทดสอบ
  const [optionExpr2, setOptionExpr2] = useState([]);

  const [testingResult, setTestingResult] = useState(""); //ผลการทดสอบ
  const [optionTestingResult, setOptionTestingResult] = useState([]);

  const [testingResultType, setTestingResultType] = useState(""); //ชื่อผลการทดสอบ
  const [optionTestResultType, setOptionTestResultType] = useState([]);

  const [testingMethod, setTestingMethod] = useState(""); //วิธีการทดสอบ
  const [optionTestingMethod, setOptionTestingMethod] = useState([]);

  const [reportNo, setReportNo] = useState("");
  const [reportDate, setreportDate] = useState("");
  const [approveDate, setApproveDate] = useState("");
  const [approveTime, setApproveTime] = useState("");

  const [provinceId, setProvinceId] = useState("");
  const [districtId, setDistrictId] = useState("");
  const [subDistrictId, setSubDistrictId] = useState("");
  const [provinceList, setProvinceList] = useState([]);
  const [districtList, setDistrictList] = useState([]);
  const [subDistrictList, setSubDistrictList] = useState([]);
  const [provinceName, setProvinceName] = useState("");
  const [districtName, setDistrictName] = useState("");
  const [subDistrictName, setSubDistrictName] = useState("");

  const [userAnalystList, setUserAnalystList] = useState([]);
  const [userApproverList, setUserApproverList] = useState([]);
  // const [nameAnalyst, setNameAnalyst] = useState([])
  // const [nameApprover, setNameApprover] = useState([])
  const [analyst, setAnalyst] = useState("");
  const [analystObj, setAnalystObj] = useState(null);
  const [approver, setApprover] = useState("");
  const [approveObj, setApproveObj] = useState(null);

  const [dataAddUser, setDataAddUser] = useState([]);

  const [labClassifyList, setLabClassifyList] = useState([]);

  const [hospitalList, setHospitalList] = useState([]);

  useEffect(() => {
    getProvinceList();
    getLaboratoryMember();
    getLabClassifyList();
    getHospitalList();
  }, []);

  useEffect(() => {
    if (labClassifyList.length > 0 && testingGene) {
      let expr2List = labClassifyList
        .filter((item) => {
          return item["lab_type_name"] === testingGene;
        })[0]
        ["lab_result"].map((item) => {
          return {
            key: item["lab_name"],
            value: item["lab_name"],
          };
        });
      setOptionExpr2(expr2List);

      if (expr2) {
        let methodList = labClassifyList
          .filter((item) => {
            return item["lab_type_name"] === testingGene;
          })[0]
          ["lab_result"].filter((item) => {
            return item["lab_name"] === expr2;
          })[0]
          ["method"].map((item) => {
            return {
              key: item["method_name"],
              value: item["method_name"],
            };
          });
        setOptionTestingMethod(methodList);

        let resultList = labClassifyList
          .filter((item) => {
            return item["lab_type_name"] === testingGene;
          })[0]
          ["lab_result"].filter((item) => {
            return item["lab_name"] === expr2;
          })[0]
          ["result"].map((item) => {
            return {
              key: item["testing_result"],
              value: item["testing_result"],
              result_name: item["result_name"],
            };
          });
        setOptionTestingResult(resultList);

        let resultTypeList = labClassifyList
          .filter((item) => {
            return item["lab_type_name"] === testingGene;
          })[0]
          ["lab_result"].filter((item) => {
            return item["lab_name"] === expr2;
          })[0]
          ["result"].map((item) => {
            return {
              key: item["result_name"],
              value: item["result_name"],
            };
          });
        setOptionTestResultType(resultTypeList);
      }
    }
  }, [testingGene, expr2]);

  // const [showList, setShowList] = useState([])
  // const [page, setPage] = useState(1)
  // const [totalPage, setTotalPage] = useState(1)

  // useEffect(() => {
  //     let start = page * 10 - 10
  //     setShowList(dataAddUser.slice(start, start + 10))
  // }, [page])

  const getHospitalList = async () => {
    setLoading(true);
    let res = await publicApi.getHospitalList();
    setLoading(false);

    if (res) {
      if (res["data"]["code"] === 200) {
        setHospitalList(
          res["data"]["hospital_list"].map((item) => {
            return {
              id: item["hospital_id"],
              name: item["hospital_name"],
              province_id: item["province_id"],
              district_id: item["district_id"],
              sub_district_id: item["sub_district_id"],
              district_name: item["district_name"],
              sub_district_name: item["sub_district_name"],
              province_name: item["province_name"],
            };
          }),
        );
      } else {
        setIsMessage({
          type: "warning",
          data: res["data"]["message_th"] || res["data"]["message"],
        });
      }
    } else {
      setIsMessage({
        type: "error",
        data: "เกิดปัญหาการใช้งาน กรุณาติดต่อเจ้าหน้าที่",
      });
    }
  };

  const searchSubDistrict = async (sub_district_name) => {
    setLoading(true);
    let res = await publicApi.searchSubDistrict(sub_district_name);
    setLoading(false);

    if (res) {
      if (res["data"]["code"] === 200) {
        // console.log(res['data'])
      } else {
        setIsMessage({
          type: "warning",
          data: res["data"]["message_th"] || res["data"]["message"],
        });
      }
    } else {
      setIsMessage({
        type: "error",
        data: "เกิดปัญหาการใช้งาน กรุณาติดต่อเจ้าหน้าที่",
      });
    }
  };

  const getProvinceList = async () => {
    setLoading(true);
    let res = await publicApi.getProvinceList();
    setLoading(false);
    if (res) {
      if (res["data"]["code"] === 200) {
        setProvinceList(
          res["data"]["province_list"].map((item) => {
            return {
              key: item["province_id"],
              value: item["province_name"],
            };
          }),
        );
      } else {
        setIsMessage({
          type: "warning",
          data: res["data"]["message_th"] || res["data"]["message"],
        });
      }
    } else {
      setIsMessage({
        type: "error",
        data: "เกิดปัญหาการใช้งาน กรุณาติดต่อเจ้าหน้าที่",
      });
    }
  };

  const getDistrictList = async (id) => {
    setLoading(true);
    let res = await publicApi.getDistrictList(id);
    setLoading(false);
    if (res) {
      if (res["data"]["code"] === 200) {
        setDistrictList(
          res["data"]["district_list"].map((item) => {
            return {
              key: item["district_id"],
              value: item["district_name"],
            };
          }),
        );
      } else {
        setIsMessage({
          type: "warning",
          data: res["data"]["message_th"] || res["data"]["message"],
        });
      }
    } else {
      setIsMessage({
        type: "error",
        data: "เกิดปัญหาการใช้งาน กรุณาติดต่อเจ้าหน้าที่",
      });
    }
  };

  const getSubDistrictList = async (id) => {
    setLoading(true);
    let res = await publicApi.getSubDistrictList(id);
    setLoading(false);
    if (res) {
      if (res["data"]["code"] === 200) {
        setSubDistrictList(
          res["data"]["sub_district_list"].map((item) => {
            return {
              key: item["sub_district_id"],
              value: item["sub_district_name"],
            };
          }),
        );
      } else {
        setIsMessage({
          type: "warning",
          data: res["data"]["message_th"] || res["data"]["message"],
        });
      }
    } else {
      setIsMessage({
        type: "error",
        data: "เกิดปัญหาการใช้งาน กรุณาติดต่อเจ้าหน้าที่",
      });
    }
  };

  const getLaboratoryMember = async () => {
    setLoading(true);
    let res = await labPersonalApi.getLaboratoryMember();
    setLoading(false);
    if (res) {
      if (res["data"]["code"] === 200) {
        // console.log(res['data'])
        setUserAnalystList(
          res["data"]["user_analyst_list"].map((i) => {
            i["key"] = i["uid"];
            i["value"] = i["pname"] + " " + i["fname"] + " " + i["lname"];
            return i;
          }),
        );
        setUserApproverList(
          res["data"]["user_approver_list"].map((i) => {
            i["key"] = i["uid"];
            i["value"] = i["pname"] + " " + i["fname"] + " " + i["lname"];
            return i;
          }),
        );
      } else if (res["data"]["code"] === 403) {
        navigate(RedirectCode400());
      } else {
        setIsMessage({ type: "warning", data: res["data"]["message_th"] });
      }
    } else {
      setIsMessage({ type: "warning", data: res["data"]["message_th"] });
    }
  };

  const getLabClassifyList = async () => {
    setLoading(true);
    let res = await labPersonalApi.getLabClassifyList();
    setLoading(false);

    if (res) {
      if (res["data"]["code"] === 200) {
        setLabClassifyList(res["data"]["lab_classify_list"]);
        setOptionTestingGene(
          res["data"]["lab_classify_list"].map((i) => {
            return {
              key: i["lab_type_name"],
              value: i["lab_type_name"],
            };
          }),
        );
      } else {
        setIsMessage({ type: "warning", data: res["data"]["message_th"] });
      }
    } else {
      setIsMessage({ type: "warning", data: res["data"]["message_th"] });
    }
  };

  const assertThaiId = (thaiId) => {
    const m = thaiId.match(/(\d{12})(\d)/);
    const digits = m[1].split("");
    const sum = digits.reduce((total, digit, i) => {
      return total + (13 - i) * +digit;
    }, 0);
    const lastDigit = `${(11 - (sum % 11)) % 10}`;
    const inputLastDigit = m[2];
    if (lastDigit !== inputLastDigit) {
      return false;
    }
    return true;
  };

  const clickAddData = () => {
    if (!testingNo) {
      setIsMessage({ type: "warning", data: "กรุณากรอกรหัสตัวอย่าง" });
      return;
    }
    if (!idCard) {
      setIsMessage({ type: "warning", data: "กรุณากรอกเลขบัตรประชาชน" });
      return;
    }
    if (!assertThaiId(idCard)) {
      setIsMessage({ type: "warning", data: "เลขบัตรประชาชนไม่ถูกต้อง" });
      return;
    }
    if (!hn) {
      setIsMessage({ type: "warning", data: "กรุณากรอกหมายเลข HN ผู้ป่วย" });
      return;
    }
    if (!prefix) {
      setIsMessage({ type: "warning", data: "กรุณาเลือกคำนำหน้า" });
      return;
    }
    if (!firstName) {
      setIsMessage({ type: "warning", data: "กรุณากรอกชื่อ" });
      return;
    }
    if (!lastName) {
      setIsMessage({ type: "warning", data: "กรุณากรอกนามสกุล" });
      return;
    }
    if (!gender) {
      setIsMessage({ type: "warning", data: "กรุณาเลือกเพศ" });
      return;
    }
    if (!age) {
      setIsMessage({ type: "warning", data: "กรุณากรอกอายุ" });
      return;
    }
    if (!testingDate) {
      setIsMessage({ type: "warning", data: "กรุณาเลือกวันที่ตรวจ" });
      return;
    }
    if (!receiveDate) {
      setIsMessage({ type: "warning", data: "กรุณาเลือกวันที่รับตัวอย่าง" });
      return;
    }
    if (!category) {
      setIsMessage({ type: "warning", data: "กรุณาเลือกชนิดของตัวอย่าง" });
      return;
    }
    // if (!sampleDescription) {
    //     setIsMessage('กรุณากรอกลักษณะตัวอย่าง')
    //     return
    // }
    if (!submitDate) {
      setIsMessage({ type: "warning", data: "กรุณาเลือกวันที่ส่งตัวอย่าง" });
      return;
    }
    if (!collectDate) {
      setIsMessage({ type: "warning", data: "กรุณาเลือกวันที่เก็บตัวอย่าง" });
      return;
    }
    if (!customerName) {
      setIsMessage({
        type: "warning",
        data: "กรุณากรอกชื่อหน่วยงานที่ส่งตัวอย่าง",
      });
      return;
    }
    if (!address) {
      setIsMessage({ type: "warning", data: "กรุณากรอกที่อยู่" });
      return;
    }
    if (!provinceId) {
      setIsMessage({ type: "warning", data: "กรุณาเลือกจังหวัด" });
      return;
    }
    if (!districtId) {
      setIsMessage({ type: "warning", data: "กรุณาเลือกอำเภอ" });
      return;
    }
    if (!subDistrictId) {
      setIsMessage({ type: "warning", data: "กรุณาเลือกตำบล" });
      return;
    }
    if (!postCode) {
      setIsMessage({ type: "warning", data: "กรุณากรอกรหัสไปรษณีย์" });
      return;
    }
    if (!testingGroup) {
      setIsMessage({ type: "warning", data: "กรุณากรอกประเภทการทดสอบ" });
      return;
    }
    if (!expr2) {
      setIsMessage({ type: "warning", data: "กรุณากรอกชื่อการทดสอบ" });
      return;
    }
    if (!testingResult) {
      setIsMessage({ type: "warning", data: "กรุณากรอกผลการทดสอบ" });
      return;
    }
    if (!reportNo) {
      setIsMessage({ type: "warning", data: "กรุณากรอกเลขที่ใบรายงานผล" });
      return;
    }
    if (!reportDate) {
      setIsMessage({ type: "warning", data: "กรุณาเลือกวันที่รายงานผล" });
      return;
    }
    if (!approveDate) {
      setIsMessage({ type: "warning", data: "กรุณาเลือกวันที่ยืนยันผล" });
      return;
    }
    if (!approveTime) {
      setIsMessage({ type: "warning", data: "กรุณาเลือกเวลาที่รายงานผล" });
      return;
    }
    if (!analyst) {
      setIsMessage({ type: "warning", data: "กรุณาเลือกผู้วิเคราะห์" });
      return;
    }
    if (!approver) {
      setIsMessage({ type: "warning", data: "กรุณาเลือกผู้รับรองผล" });
      return;
    }
    if (!testingGene) {
      setIsMessage({ type: "warning", data: "กรุณาเลือกชนิดการทดสอบ" });
      return;
    }
    // if (!testingResultType) {
    //     setIsMessage('กรุณาเลือกชื่อผลการทดสอบ')
    //     return
    // }
    if (!testingMethod) {
      setIsMessage({ type: "warning", data: "กรุณาเลือกวิธีการทดสอบ" });
      return;
    }

    let id = uuidv4();

    let data = {
      id: id,
      testing_no: testingNo,
      id_card: idCard,
      hn: hn,
      sample_name: {
        prefix: prefix,
        first_name: firstName,
        last_name: lastName,
      },
      gender: gender,
      age: age,
      testing_group: testingGroup,
      expr2: expr2,
      testing_date: testingDate,
      receive_date: receiveDate,
      customer_id: customerId,
      customer_name: customerName,
      customer_address: {
        address: address,
        province_id: provinceId,
        province_name: provinceName,
        district_id: districtId,
        district_name: districtName,
        sub_district_id: subDistrictId,
        sub_district_name: subDistrictName,
        post_code: postCode,
      },
      submit_date: submitDate,
      collect_date: collectDate,
      category: category,
      sample_description: "-",
      report_no: reportNo,
      report_date: reportDate,
      approve_date: approveDate,
      approve_time: approveTime,
      testing_result: testingResult,
      testing_result_type: testingResultType,
      testing_method: testingMethod,
      testing_gene_type: testingGene,
      analyst: {
        prefix: analystObj?.pname || "",
        first_name: analystObj?.fname || "",
        last_name: analystObj?.lname || "",
      },
      approver: {
        prefix: approveObj?.pname || "",
        first_name: approveObj?.fname || "",
        last_name: approveObj?.lname || "",
      },
    };
    setDataAddUser([...dataAddUser, data]);
    // if (dataAddUser.length > 0) {
    //     setTotalPage(Math.ceil(dataAddUser.length / 10))
    // }
  };

  useEffect(() => {
    // console.log(dataAddUser);
  }, [dataAddUser]);

  // const getName = (id, list) => {
  //     let text = ''
  //     list.forEach(item => {
  //         if (item['key'] === id) {
  //             text = item['value']
  //         }
  //     });
  //     return text
  // }

  const backButtonClick = () => {
    navigate("/laboratory/inputdata");
  };

  const [openModal, setOpenModal] = useState(false);
  const onclickOpenModal = () => {
    setOpenModal(true);
  };

  const inputLab = async () => {
    let errorList = [];
    for (let index = 0; index < dataAddUser.length; index += 1) {
      setLoading(true);
      let res = await labPersonalApi.inputLab(dataAddUser[index]);
      setLoading(false);
      if (res) {
        if (res["data"]["code"] === 200) {
        } else if (res["data"]["code"] === 403) {
          navigate(RedirectCode400());
          break;
        } else {
          errorList.push({
            testing_no: dataAddUser[index]["testing_no"],
            error_message: res["data"]["message_th"],
          });
          break;
        }
      } else {
        setIsMessage({ type: "warning", data: res["data"]["message_th"] });
      }
    }
    if (errorList.length === 0) {
      navigate("/inputdata");
    } else {
      setIsMessage({
        type: "error",
        data: errorList
          .map((item) => {
            return `${item["testing_no"]} : ${item["error_message"]}`;
          })
          .join("\n"),
      });
    }
  };

  const clearData = () => {
    setTestingNo("");
    setIdCard("");
    setHN("");
    setPrefix("");
    setFirstName("");
    setLastName("");
    setTestingDate("");
    setReceiveDate("");
    setCategory("");
    // setSampleDescription('')
    setSubmitDate("");
    setCollectDate("");
    setCustomerId("");
    setCustomerName("");
    setAddress("");
    setPostCode("");
    setTestingGroup(""); //ประเภทการทดสอบ
    setTestingGene(""); //ชนิดการทดสอบ
    setExpr2(""); //ชื่อการทดสอบ
    setTestingResult(""); //ผลการทดสอบ
    setTestingResultType(""); //ชื่อผลการทดสอบ
    setTestingMethod(""); //วิธีการทดสอบ
    setReportNo("");
    setreportDate("");
    setApproveDate("");
    setApproveTime("");
    setProvinceId("");
    setDistrictId("");
    setSubDistrictId("");
    setAnalyst("");
    setApprover("");
  };

  const columns = [
    {
      name: "ตัวเลือก",
      selector: (i) => (
        <div className={styles.imgDelete}>
          <img
            style={{ cursor: "pointer" }}
            src={deleteIcon}
            onClick={() => {
              setDataAddUser(
                dataAddUser.filter((item) => {
                  return item["id"] !== i["id"];
                }),
              );
            }}
          />
        </div>
      ),
    },
    {
      name: "รหัสตัวอย่าง",
      selector: (i) => <div>{i["testing_no"]}</div>,
      minWidth: "200px",
    },
    {
      name: "เลขบัตรประชาชนผู้ป่วย",
      selector: (i) => <div>{i["id_card"]}</div>,
      minWidth: "230px",
    },
    {
      name: "หมายเลข HN",
      selector: (i) => <div>{i["hn"]}</div>,
      minWidth: "200px",
    },
    {
      name: "คำนำหน้า",
      selector: (i) => <div>{i["sample_name"]["prefix"]}</div>,
    },
    {
      name: "ชื่อ",
      selector: (i) => <div>{i["sample_name"]["first_name"]}</div>,
    },
    {
      name: "นามสกุล",
      selector: (i) => <div>{i["sample_name"]["last_name"]}</div>,
    },
    {
      name: "อายุ",
      selector: (i) => <div>{i["age"]}</div>,
    },
    {
      name: "เพศ",
      selector: (i) => <div>{i["gender"] === "male" ? "ชาย" : "หญิง"}</div>,
    },
    {
      name: "วันที่ตรวจ",
      selector: (i) => <div>{i["testing_date"]}</div>,
      minWidth: "150px",
    },
    {
      name: "วันที่รับตัวอย่าง",
      selector: (i) => <div>{i["receive_date"]}</div>,
      minWidth: "150px",
    },
    {
      name: "ชนิดของตัวอย่าง",
      selector: (i) => <div>{i["category"]}</div>,
      minWidth: "200px",
      wrap: true,
    },
    {
      name: "วันที่เก็บตัวอย่าง",
      selector: (i) => <div>{i["collect_date"]}</div>,
      minWidth: "150px",
    },
    {
      name: "หน่วยงานที่ส่งตัวอย่าง",
      selector: (i) => <div>{i["customer_name"]}</div>,
      minWidth: "250px",
      wrap: true,
    },
    {
      name: "ที่อยู่",
      selector: (i) => <div>{i["customer_address"]["address"]}</div>,
      minWidth: "150px",
      wrap: true,
    },
    {
      name: "ตำบล",
      selector: (i) => <div>{i["customer_address"]["sub_district_name"]}</div>,
      minWidth: "150px",
      wrap: true,
    },
    {
      name: "อำเภอ",
      selector: (i) => <div>{i["customer_address"]["district_name"]}</div>,
      minWidth: "150px",
      wrap: true,
    },
    {
      name: "จังหวัด",
      selector: (i) => <div>{i["customer_address"]["province_name"]}</div>,
      minWidth: "150px",
      wrap: true,
    },
    {
      name: "รหัสไปรษณีย์",
      selector: (i) => <div>{i["customer_address"]["post_code"]}</div>,
      minWidth: "150px",
      wrap: true,
    },
    {
      name: "ประเภทการทดสอบ",
      selector: (i) => <div>{i["testing_group"]}</div>,
      minWidth: "250px",
      wrap: true,
    },
    {
      name: "ชนิดการทดสอบ",
      selector: (i) => <div>{i["testing_gene_type"]}</div>,
      minWidth: "200px",
      wrap: true,
    },
    {
      name: "ชื่อการทดสอบ",
      selector: (i) => <div>{i["expr2"]}</div>,
      minWidth: "200px",
      wrap: true,
    },
    {
      name: "ผลการทดสอบ",
      selector: (i) => <div>{i["testing_result"]}</div>,
      minWidth: "250px",
      wrap: true,
    },
    {
      name: "ชื่อผลการทดสอบ",
      selector: (i) => <div>{i["testing_result_type"]}</div>,
      minWidth: "250px",
      wrap: true,
    },
    {
      name: "วิธีการทดสอบ",
      selector: (i) => <div>{i["testing_method"]}</div>,
      minWidth: "250px",
      wrap: true,
    },
    {
      name: "เลขที่ใบรายงานผล",
      selector: (i) => <div>{i["report_no"]}</div>,
      minWidth: "200px",
      wrap: true,
    },
    {
      name: "วันที่รายงานผล",
      selector: (i) => <div>{i["report_date"]}</div>,
      minWidth: "150px",
    },
    {
      name: "วันที่ยืนยันผล",
      selector: (i) => <div>{i["approve_date"]}</div>,
      minWidth: "150px",
    },
    {
      name: "เวลาที่ยืนยันผล",
      selector: (i) => <div>{i["approve_time"]}</div>,
      minWidth: "150px",
    },
    {
      name: "ผู้วิเคราะห์ผล",
      selector: (i) => (
        <div>
          {i["analyst"]["prefix"] +
            " " +
            i["analyst"]["first_name"] +
            " " +
            i["analyst"]["last_name"]}
        </div>
      ),
      minWidth: "250px",
    },
    {
      name: "ผู้รับรองผล",
      selector: (i) => (
        <div>
          {i["approver"]["prefix"] +
            " " +
            i["approver"]["first_name"] +
            " " +
            i["approver"]["last_name"]}
        </div>
      ),
      minWidth: "250px",
    },
  ];

  return (
    <div class="bg-[#ffffff] pb-[30px]">
      <div className={styles.blockContent}>
        <div
          className={`text-3xl md:text-[18px] flex font-bold mt-2 mb-4 font-['Prompt-SemiBold'] `}
        >
          ลงข้อมูลรายบุคคล
        </div>
        <div>
          <div className={styles.textBack}>ข้อมูลผู้ป่วย</div>
          <div className={styles.inputAlign}>
            <Input
              placeholder="รหัสตัวอย่าง"
              value={testingNo}
              setValue={setTestingNo}
            />
            <Input
              regex={regex.pid()}
              placeholder="เลขบัตรประชาชนผู้ป่วย"
              value={idCard}
              setValue={setIdCard}
            />
            <Input
              placeholder="หมายเลข HN ผู้ป่วย"
              value={hn}
              setValue={setHN}
            />
            <Select
              placeholder="คำนำหน้าชื่อผู้ป่วย"
              value={prefix}
              setValue={setPrefix}
              list={optionPrefix}
            />
            <Input
              placeholder="ชื่อ"
              value={firstName}
              setValue={setFirstName}
            />
            <Input
              placeholder="นามสกุล"
              value={lastName}
              setValue={setLastName}
            />
            <Select
              label="เพศ"
              placeholder="เพศ"
              value={gender}
              setValue={setGender}
              list={optionGender}
            />
            <Input
              regex={regex.number()}
              placeholder="อายุ ณ วันที่ได้รับการตรวจ"
              value={age}
              setValue={setAge}
            />
          </div>
          <div className={styles.textBack}>ข้อมูลตัวอย่าง</div>
          <div className={styles.inputAlign}>
            <Input
              type="date"
              placeholder="วันที่ตรวจ"
              value={testingDate}
              setValue={setTestingDate}
            />
            <Input
              type="date"
              placeholder="วันที่รับตัวอย่าง"
              value={receiveDate}
              setValue={setReceiveDate}
            />
            <Select
              placeholder="ชนิดของตัวอย่าง"
              value={category}
              setValue={setCategory}
              list={optionCategory}
            />
            {/* <Input placeholder='ลักษณะตัวอย่าง' value={sampleDescription} setValue={setSampleDescription} /> */}
            <div></div>
            <Input
              type="date"
              placeholder="วันที่ส่งตัวอย่าง"
              value={submitDate}
              setValue={setSubmitDate}
            />
            <Input
              type="date"
              placeholder="วันที่เก็บตัวอย่าง"
              value={collectDate}
              setValue={setCollectDate}
            />
            <AutoComplete
              id={customerId}
              placeholder="ชื่อหน่วยงานที่ส่งตัวอย่าง"
              label={
                "ชื่อหน่วยงานที่ส่งตัวอย่าง (ชื่อหรือรหัสสถานพยาบาล 9 หลัก)"
              }
              list={hospitalList}
              callBack={(res) => {
                setCustomerId(res["id"]);
                setCustomerName(res["name"]);
                setProvinceId(res["province_id"]);
                setProvinceName(res["province_name"]);
                setDistrictId(res["district_id"]);
                setDistrictName(res["district_name"]);
                setSubDistrictId(res["sub_district_id"]);
                setSubDistrictName(res["sub_district_name"]);
                getDistrictList(res["province_id"]);
                getSubDistrictList(res["district_id"]);
              }}
            ></AutoComplete>
            {/* <Input placeholder='ชื่อหน่วยงานที่ส่งตัวอย่าง' value={customerName} setValue={setCustomerName} /> */}
            <Input
              placeholder="ที่อยู่ของหน่วยงาน (บ้านเลขที่ หรือ ชื่อตึก)"
              value={address}
              setValue={setAddress}
            />
            <Input
              regex={regex.postCode()}
              placeholder="รหัสไปรษณีย์"
              value={postCode}
              setValue={setPostCode}
            />
            <Select
              placeholder="จังหวัด"
              value={provinceId}
              setValue={(e) => {
                setProvinceId(e);

                for (let i = 0; i < provinceList.length; i += 1) {
                  let item = provinceList[i];
                  // console.log(item)
                  if (item.key === e) {
                    // console.log(item["value"]);
                    setProvinceName(item["value"]);
                  }
                }
                setDistrictId("");
                setDistrictList([]);
                setSubDistrictId("");
                setSubDistrictList([]);
                getDistrictList(e);
              }}
              list={provinceList}
            ></Select>
            <Select
              placeholder="อำเภอ"
              value={districtId}
              setValue={(e) => {
                setDistrictId(e);
                for (let i = 0; i < districtList.length; i += 1) {
                  let item = districtList[i];
                  // console.log(item)
                  if (item.key === e) {
                    // console.log(item["value"]);
                    setDistrictName(item["value"]);
                  }
                }
                setSubDistrictId("");
                setSubDistrictList([]);
                getSubDistrictList(e);
              }}
              list={districtList}
            ></Select>
            <Select
              placeholder="ตำบล"
              value={subDistrictId}
              setValue={(e) => {
                setSubDistrictId(e);
                for (let i = 0; i < subDistrictList.length; i += 1) {
                  let item = subDistrictList[i];
                  // console.log(item)
                  if (item.key === e) {
                    //   console.log(item["value"]);
                    setSubDistrictName(item["value"]);
                  }
                }
              }}
              list={subDistrictList}
            ></Select>
          </div>
          <div className={styles.textBack}>ข้อมูลผลการทดสอบ</div>
          <div className={styles.inputAlign}>
            <Select
              placeholder="ประเภทการทดสอบ"
              value={testingGroup}
              setValue={setTestingGroup}
              list={optionTestingGroup}
            />
            <Select
              placeholder="ชนิดการทดสอบ"
              value={testingGene}
              setValue={(e) => {
                setTestingGene(e);
                setExpr2("");
                setOptionExpr2([]);
                setTestingResult("");
                setOptionTestingResult([]);
                setTestingResultType("");
                setTestingMethod("");
                setOptionTestingMethod([]);
              }}
              list={optionTestingGene}
            />
            <Select
              placeholder="ชื่อการทดสอบ"
              value={expr2}
              setValue={(e) => {
                setExpr2(e);
                setTestingResult("");
                setOptionTestingResult([]);
                setTestingResultType("");
                setTestingMethod("");
                setOptionTestingMethod([]);
              }}
              list={optionExpr2}
            />
            <Input
              placeholder="เลขที่ใบรายงานผล"
              value={reportNo}
              setValue={setReportNo}
            />
            <Select
              placeholder="ผลการทดสอบ"
              value={testingResult}
              setValue={(e) => {
                setTestingResult(e);
                for (
                  let index = 0;
                  index < optionTestingResult.length;
                  index += 1
                ) {
                  let item = optionTestingResult[index];
                  if (item["key"] === e) {
                    setTestingResultType(item["result_name"]);
                  }
                }
              }}
              list={optionTestingResult}
            />
            <Input
              type="date"
              placeholder="วันที่รายงานผล"
              value={reportDate}
              setValue={setreportDate}
            />
            {/* <Select placeholder='ชื่อผลการทดสอบ' value={testingResultType} setValue={setTestingResultType} list={optionTestResultType} /> */}
            <Select
              placeholder="วิธีการทดสอบ"
              value={testingMethod}
              setValue={setTestingMethod}
              list={optionTestingMethod}
            />
            <Input
              type="date"
              placeholder="วันที่ยืนยันผล"
              value={approveDate}
              setValue={setApproveDate}
            />
            <Input
              type="time"
              placeholder="เวลาที่รายงานผล"
              value={approveTime}
              setValue={setApproveTime}
            />
          </div>
          <div className={styles.inputAlign}>
            <div>
              <div className={styles.textBack}>ข้อมูลผู้วิเคราะห์</div>
              <Select
                disabledLabel={true}
                placeholder="เลือกผู้วิเคราะห์"
                value={analyst}
                setValue={(e) => {
                  // console.log(e);
                  setAnalyst(e);
                  // console.log(userAnalystList);
                  userAnalystList.forEach((item) => {
                    //   console.log(item);
                    if (item["key"] == e) {
                      setAnalystObj({
                        pname: item["pname"],
                        fname: item["fname"],
                        lname: item["lname"],
                      });
                    }
                  });
                }}
                list={userAnalystList}
              />
            </div>
            <div>
              <div className={styles.textBack}>ข้อมูลผู้รับรองผล</div>
              <Select
                disabledLabel={true}
                placeholder="เลือกผู้รับรองผล"
                value={approver}
                setValue={(e) => {
                  // console.log(e);
                  setApprover(e);
                  // console.log(userApproverList);
                  userApproverList.forEach((item) => {
                    //   console.log(item);
                    if (item["key"] == e) {
                      setApproveObj({
                        pname: item["pname"],
                        fname: item["fname"],
                        lname: item["lname"],
                      });
                    }
                  });
                }}
                list={userApproverList}
              />
            </div>
          </div>
        </div>
        <div className={styles.align}>
          <Button
            style={{ width: 160, margin: "0 3%" }}
            onClick={() => {
              clickAddData();
            }}
          >
            เพิ่มข้อมูล
          </Button>
          <Button
            style={{
              width: 160,
              background: "#ffffff",
              margin: "0 3%",
              border: "1px solid #FF9768",
              color: "#FF9768",
            }}
            onClick={clearData}
          >
            ล้างข้อมูล
          </Button>
        </div>

        <div className={styles.align}>
          <DataTable
            className="classTable"
            columns={columns}
            data={dataAddUser}
            customStyles={customStyles}
            noDataComponent={<div style={{ margin: "10%" }}>ไม่พบข้อมูล</div>}
          />
        </div>
        <div className={styles.text}>
          **ท่านสามารถแก้ไขข้อมูลได้ภายใน 24 ชั่วโมงหลังจากกดยืนยันการลงข้อมูล
          กรุณาตรวจสอบข้อมูลให้ถูกต้อง**
        </div>
        <div className={styles.align}>
          <Button
            style={{
              width: 160,
              background: "#FFFFFF",
              margin: "3%",
              color: "#42A1EF",
            }}
            onClick={backButtonClick}
          >
            ย้อนกลับ
          </Button>
          <Button
            style={{ width: 160, margin: "3%" }}
            onClick={onclickOpenModal}
          >
            ถัดไป
          </Button>
        </div>
        {openModal ? (
          <>
            <ModaluploadResultsInput
              onClose={() => {
                setOpenModal(false);
              }}
              dataList={dataAddUser}
              onSubmit={() => {
                setOpenModal(false);
                inputLab();
              }}
            />
          </>
        ) : null}
      </div>
    </div>
  );
}
export default AddIndividualData;
